import { Children, createContext, useState } from "react";


const ThemeContext = createContext();




export const ThemeProvider = ({children}) => {
    const [theme, setTheme] = useState('T1002');
    const [loginuser, setLoginUser] = useState("muratt"); 
    const [userName, setUserName] = useState("muratt"); 
    const [varCode, setVarCode ] = useState("X");
    const [varCode2, setVarCode2 ] = useState("X");
    const [varCode3, setVarCode3 ] = useState("X");
    const [varCode4, setVarCode4 ] = useState("88");
    const [varCode5, setVarCode5 ] = useState("");  //for red
    const [varCode6, setVarCode6 ] = useState(""); //for reduction
    const [varCode7, setVarCode7 ] = useState(""); //for base price
    const [varCode8, setVarCode8 ] = useState("");
    const [varCode9, setVarCode9 ] = useState(""); // for Rules
    const [varCode10, setVarCode10 ] = useState(""); // for Rules
    const [varCode11, setVarCode11 ] = useState(""); // for Rules
    const [varCode12, setVarCode12 ] = useState(""); // for Rules
    const [varCode13, setVarCode13 ] = useState("0"); // for Rules
    const [varCode14, setVarCode14 ] = useState("PUBL"); // for Rules
    const [varCode15, setVarCode15 ] = useState("QUAT"); // for Rules


    const values = {
        theme,
        setTheme,
        loginuser,
        setTheme,
        userName,
        setUserName,
        varCode,
        setVarCode,
        varCode2,
        setVarCode2,
        varCode3,
        setVarCode3,
        varCode4,
        setVarCode4,
        varCode5,
        setVarCode5,
        varCode6,
        setVarCode6,
        varCode7,
        setVarCode7,
        varCode8,
        setVarCode8,
        varCode9,
        setVarCode9,
        varCode10,
        setVarCode10,
        varCode11,
        setVarCode11,
        varCode12,
        setVarCode12,
        varCode13,
        setVarCode13,
        varCode14,
        setVarCode14,
        varCode15,
        setVarCode15,


    };
    return (<ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>
      );
}

export default ThemeContext;